import { Component, Host, h, Prop, Element } from '@stencil/core';

import { createCSSVariablesForFontsizes } from '../../../utils/utils';

export type PSpaceProp = undefined | '' | 'v-space-30';

const ACC = (window as any).ACC;

@Component({
  tag: 'lilu-p',
  styleUrl: 'lilu-p.scss',
  shadow: true,
})
export class LiluP {
  @Prop() font = 'regular';
  @Prop() color = 'nero';
  @Prop() size = 'size-10 lg-size-12';
  @Prop() ellipsis = '';
  @Prop() lineHeight = 'default';
  @Prop() space?: PSpaceProp;
  @Prop() icon_size = 'size-10 lg-size-12';
  @Prop() dataModal?: string;
  @Prop() dataListUrl?: string;
  @Prop() type?: string;
  @Prop() icon: string = null;
  @Prop() icon_color = '';
  @Prop() icon_halfColor = '';
  @Prop() CSRFToken?: any;
  @Prop() appearance?: string = null;
  @Prop() modalId = 'storefinder';
  @Prop() modalDataSource = '_response.data';
  @Prop() inline?: boolean = false;

  @Element() element: HTMLElement;

  componentDidLoad() {
    if (ACC !== undefined) {
      this.CSRFToken = ACC.config.CSRFToken;
    }
    createCSSVariablesForFontsizes(this.element, this.size);
  }

  render() {
    if (this.icon) {
      return this.getHTMLWithIcon();
    } else {
      return this.getHTMLWithoutIcon();
    }
  }

  getHTMLWithIcon() {
    const hostClasses = [this.size, this.space || ''].join(' ');

    return (
      <Host class={`${hostClasses} ${this.ellipsis} ${this.inline ? 'inline' : ''}`}>
        <div class={`icon-text ${this.appearance ? this.appearance : ''}`}>
          <lilu-icon type={this.icon} size={this.icon_size} color={this.icon_color} half-color={this.icon_halfColor}></lilu-icon>
          <p class={`p ${this.font} size ${this.color} ${this.ellipsis} line-height-${this.lineHeight}`}>
            <slot></slot>
          </p>
        </div>
      </Host>
    );
  }

  getHTMLWithoutIcon() {
    const hostClasses = [
      //don't add the size if there is a type defined (only used for hero right now)
      this.type ? '' : this.size,
      this.space || '',
    ].join(' ');

    return (
      <Host class={`${hostClasses} ${this.ellipsis} ${this.inline ? 'inline' : ''}`} part={`${this.type ? '' : this.size}`}>
        <p
          part="p"
          class={`p ${this.font} ${this.type ? this.type : 'size'} ${this.color} ${this.ellipsis} ${this.appearance ? this.appearance : ''} line-height-${this.lineHeight}`}
        >
          <slot></slot>
        </p>
      </Host>
    );
  }
}
